<template lang="pug">
.registration-dashboard
	.registration-dashboard__inner
		button.registration-dashboard__logout(@click="logout" v-if="!isLoading")
			i.fas.fa-arrow-from-left
			span Log out
		div.registration-dashboard__content(v-html="copyHTML")
		div(v-if="alertHTML" v-html="alertHTML")
		//- Optional Questions button
		.registration-resource.registration-resource--optional(v-if="!isLoggedOut")
			a.registration-resource__heading(href='#' @click.prevent="toggleOptionalQuestions($event)") {{optionalQuestions.heading}}
		.registration-dashboard__wysiwyg(v-if="!isLoggedOut") {{optionalQuestions.copy}}
		button.registration-flyout__error-wrapper(@click.prevent="toggleOptionalQuestions($event)" v-if="!isLoggedOut && isReminder && !optionalQuestionsDismissed" tabindex="0") 
			.registration-flyout__error
				p
					i.fa-exclamation.fas
					|	{{ isReminder }}
			button.registration-flyout__error-close(title="Dismiss" @click.prevent.stop="handleQuestionAlertClose($event)")
				i.fas.fa-times.registration-flyout__error-close-icon
		div(v-if="!isLoggedOut" v-html="footerHTML")
</template>

<script>
import dashboardCopy from "../../../../data/registrationDashboard.json"
import { mapGetters, mapMutations} from "vuex";
export default {
	name: "PageDashboard",
	data() {
		return{
			copy: dashboardCopy.registrationDashboard.default,
			copyEndpoint: '/api/userdashboard/getcontent/dashboard',
			logoutEndpoint: '/api/account/logout',
			copyHTML: '',
			footerHTML: '',
			alertHTML: '',
			optionalQuestions: {
				copy: '',
				heading: ''
			},
			// copyHTML1: '',
			// copyHTML2: '',
			isReminder: '',
			redirectURL: window.location.origin,
			isLoggedOut: false,
		}
	},
	computed: {
		...mapGetters(["optionalQuestionsDismissed", "isLoading"])
	},
	methods: { 
		...mapMutations(["setDisabled", "setLoading"]),
		logout() {
			return new Promise(async res => {
					await fetch(this.logoutEndpoint, {
						method: 'POST',
						headers: {
							'Content-type':'application/json'
						},
					})
					.then((response) => response.json())
					.then(data => {
						this.copyHTML = '<p class="registration-dashboard__title">Logout successful, now redirecting...</p>'
						this.isLoggedOut = true
					})
					.catch(error => {
						console.error(error);
					})
					.finally(() => {
						this.$parent.isLoggedIn = false
						setTimeout(() => {
							window.location = this.redirectURL
						}, 1500)
					});
				})
		},
		toggleOptionalQuestions(e) {
			if (!!e.target.closest('.registration-flyout__error-close')) return;
			this.$store.commit('setOptionalQuestions', true)
		},
		handleQuestionAlertClose(e) {
			const wrapper = e.target.closest('.registration-flyout__error-wrapper');
			this.$store.commit('setOptionalQuestions', false);
			window.localStorage.setItem('optionalQuestionsDismissed', true);
			wrapper.remove();
		}
	},
	mounted() {
		this.setLoading(true)
		fetch(this.copyEndpoint, {
			method: 'GET',
			headers: {
				'Content-Type': 'application/json'
			},
		}).then((response) => response.json())
			.then((data) => {
				this.copyHTML = data.content;
				this.footerHTML = data.footer;
				this.isReminder = data.reminder;
				this.alertHTML = data.alert;
				this.optionalQuestions = data.optionalQuestions;
				setTimeout(() => {
					this.setLoading(false);
					document.querySelector('dialog.registration-dialog')?.showModal();
				}, 1000);
			});
	},
};
</script>

<style lang="scss">
.registration-dashboard {
		background: var(--registration-blue);
		color: $white;
		padding: 33px 33px 33px 19px;

        @include mq(sm) {
		    padding: 33px 43px 33px 19px;
        }

        @include mq(md) {
		    padding: 33px 53px 33px 19px;
        }

		&__heading {
				font-size: 2em;
				font-weight: 600;
				margin-bottom: var(--registration-gap-base);
				font-family: var(--registration-font-family-bold);
		}
		&__subheading {
				font-weight: 600;
				font-family: var(--registration-font-family);
				font-size: 1.15em;
				margin-bottom: calc(var(--registration-gap-base)*2);
		}
		&__title {
				font-weight: 600;
				font-family: var(--registration-font-family);
				font-size: 1.5em;
				margin-bottom: var(--registration-gap-base);
				&--reminder {
					background: #f00;
					color: #fff;
					width: 100%;
					text-align: center;
					padding: 0.25rem;
					cursor: pointer;
				}
		}
		&__content {
			margin-bottom: var(--registration-gap-base);
		}
		&__wysiwyg {
			font-family: var(--registration-font-family);
			// match icon above
			margin-left: 29px;
			ul {
				margin-top: calc(var(--registration-gap-base)*-1);
				padding-left: calc(var(--registration-gap-base)*3);
			}
		}
		&__questions {
			display: flex; 
			flex-direction: row;
			flex-wrap: wrap;
			justify-content: start;
			align-items: center;
			gap: calc(var(--registration-gap-base)*.5);
			margin-bottom: calc(var(--registration-gap-base)*2);
		}
		&__question {
				color: var(--registration-button-teal);
				display: inline-flex;
				gap: var(--registration-gap-base);
				flex: 1 1 49%;
				max-width: 370px;
				flex-direction: row;
				flex-wrap: nowrap;
				font-size: 1em;
				font-weight: 600;
				align-items: center;
				justify-content: space-around;
				&:is(span) {
					&:hover {
						span {
								color: var(--registration-button-teal);
								text-decoration: none;
						}
					}
				}
				i {
						font-size: 2em;
				}
				span {
						flex-basis: 90%;
				}
				
				&:hover {
						text-decoration: none;
						color: var(--registration-button-teal-hover);
						span {
								text-decoration: underline;
						}
				}
		}
		&__logout {
			@include clean(button);
            position: absolute;
            top: 2rem;
            right: 54px;
            text-align: right;
			color: var(--registration-button-teal);
			cursor: pointer;
			display: inline-flex;
			gap: var(--registration-gap-base);
			flex-direction: row;
			flex-wrap: nowrap;
			flex-basis: 49%;
			font-size: 1em;
			font-weight: 600;
			align-items: center;
			justify-content: space-around;

            @include mq(sm) {
                right: 64px;
            }

            @include mq(md) {
                right: 74px;
            }

			i {
					font-size: 2em;
			}
			span {
					flex-basis: 90%;
					text-align: left;
			}
			&:hover {
					text-decoration: none;
					color: var(--registration-button-teal-hover);
					span {
							text-decoration: underline;
					}
			}
		}
}
.registration-resource {
		font-family: var(--registration-font-family);
		margin-top: var(--registration-gap-base);
		&--optional {
			+ .registration-dashboard__wysiwyg {
				margin-bottom: calc(var(--registration-gap-base) * 2.4);
			}
		}    
		&__heading {
			color: #fff;
			font-size: 1.5em;
			font-weight: bold;
			margin-bottom: calc(var(--registration-gap-base)*.5);
			text-transform: capitalize;
			&:before {
					// replace w/ icon
					content:'\f061';
					color: var(--registration-button-teal);
					font-family: var(--registration-font-family-icon);
					margin-right: calc(var(--registration-gap-base)*.25);
					display:inline-block;
					&:hover {
						text-decoration: none;
					}
			}
			&:hover {
				color: var(--registration-button-teal);
				&:before {
					text-decoration: none;
				}
			}
		}
}
.registration-flyout {
	&__error {
		transition: 0.15s ease;
		p {
			flex-wrap: nowrap;
			align-items: flex-start;
		}
	i {
			transition: 0.15s ease;
			min-width: 2em;
	}
		&-close {
			background: transparent;
			border: none;
			padding: 0.875rem 0 0;
			padding-right: 0.5rem;
			line-height: 1;
			height: 1.5rem;
			&-icon {
				background: transparent;
				font-size: 1.5rem;
				color: $white;
				transition: 0.15s ease;
			}
			&:hover {
				.registration-flyout__error-close-icon {
					color: $danger;
					font-size: 1.75rem;
				}
			}
		}
  }
  &__error-wrapper {
		cursor: pointer;
		transition: 0.15s ease;
		display: flex;
		align-items: flex-start;
		background: transparent;
		&:hover:not(:has(.registration-flyout__error-close:hover)) {
			border-color: var(--registration-button-teal);
			.registration-flyout__error {
				i {
					background: var(--registration-button-teal);
					color: var(--registration-blue);
				}
			}
		}
  }
}
.registration-dialog {
	max-width: 540px;
	border: 2px solid #999999;
	padding: 0;
	width: calc(100% - 2rem);
	max-height: 80vh;

	&::backdrop {
		background: rgba(0, 0, 0, 0.35);
		backdrop-filter: blur(3px);
	}

	&__heading {
		border-bottom: 2px solid #999999;
		padding: 0.5rem 1rem;
		display: flex;
		flex-direction: row;
		justify-content: space-between;
		align-items: center;

		& > * {
			margin: 0;
		}
	}

	&__title {
		padding-right: 1rem;
	}

	&__content {
		padding: 1rem;
		overflow: hidden;
	}

	&__close {
		background: transparent;
		border: none;
		padding: 0.25rem;

		i {
			font-size: 2rem;
		}
	}

	&__image {
		width: 100%;
		height: auto;
	}

	&__text {
		margin: 1rem 0;
	}

	&__link {
		float: right;
		background: #385e9d;
		color: #fff;
		padding: 0.5rem 1rem;
		min-width: 150px;
		max-width: 80%;
		text-align: center;

		&:hover {
			background: lighten(#385e9d, 10%);
			color: #fff;
		}
	}
}
</style>
